import { render, staticRenderFns } from "./StarterAvatar.vue?vue&type=template&id=384c8ffd"
import script from "./StarterAvatar.vue?vue&type=script&lang=js"
export * from "./StarterAvatar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports